import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/how-it-works')({});
